import { render, staticRenderFns } from "./insure.vue?vue&type=template&id=966b5700&scoped=true&"
import script from "./insure.vue?vue&type=script&lang=js&"
export * from "./insure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "966b5700",
  null
  
)

export default component.exports